import { useOnValueChange } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { PopupDropdownMenu } from '@calendly/ui/components/menu';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { filterResults, resetTriggerExpand } from 'actions/home_bar/scope_dropdown';
import SearchInput from 'components/core/search_input';
import { useMyCalendlyDropdownEventProps } from 'components/empty_state';
import { TRACKING_EVENT_NAMES, useTrack } from 'hooks/analytics_events';
import { filterTermSelector, forceExpandTriggeredSelector } from 'selectors/home_bar';
import { isNoTouchDevice } from 'services/touch_device_detection';
import Body from './body';
import ScopeDropdownControl from './control';
const containerCss = "c1xjy8ry";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const menuCss = "mjhklpr";
const Menu = forwardRef((props, ref) => <PopupDropdownMenu ref={ref} {...props} className={classNames(menuCss, props.className)} />);
const filterInputCss = "f10kbpku";
const FilterInput = forwardRef((props, ref) => <SearchInput ref={ref} {...props} className={classNames(filterInputCss, props.className)} />);
const ScopeDropdown = () => {
  const dispatch = useDispatch();
  const filterTerm = useSelector(filterTermSelector);
  const forceExpandTriggered = useSelector(forceExpandTriggeredSelector);
  const [toggleDropdown, Dropdown, isExpanded] = useDropdown();
  const track = useTrack();
  const {
    pathname
  } = useLocation();
  const properties = useMyCalendlyDropdownEventProps(pathname);
  useOnValueChange(forceExpandTriggered, () => {
    if (forceExpandTriggered && !isExpanded) {
      toggleDropdown();
      dispatch(resetTriggerExpand());
    }
  });
  useOnValueChange(isExpanded, () => {
    if (!isExpanded || !properties) return;
    track({
      name: TRACKING_EVENT_NAMES.DROPDOWN_SELECTED,
      properties
    });
  });
  return <Container data-component="scope-switcher">
      <ScopeDropdownControl data-calendly-label="scope-button" onClick={toggleDropdown} isExpanded={isExpanded} />
      <Dropdown>
        <Menu data-component="scope-dropdown-menu">
          <FullStoryMask>
            <FilterInput value={filterTerm} onChange={value => dispatch(filterResults(value))} placeholder={I18n.t('publisher.event_types.filter')} autoFocus={isNoTouchDevice()} />
            <Body />
          </FullStoryMask>
        </Menu>
      </Dropdown>
    </Container>;
};
export default ScopeDropdown;

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.js");